export enum InputTypeEnum {
  Text = 'text',
  Password = 'password',
}
